import axiosInstance from '../api';

export interface LiveStream {
  id: string;
  hospital_id: string;
  created_by: string;
  specialty_id: string | null;
  title: string;
  description: string | null;
  visibility: 'hospital_only' | 'public';
  status: 'scheduled' | 'live' | 'ended' | 'error';
  thumbnail_path: string | null;
  started_at: string | null;
  ended_at: string | null;
  last_heartbeat_at: string | null;
  archive_video_id: string | null;
  archive_video_accessible: boolean;
  created_at: string;
  updated_at: string;
  hls_url: string;
}

export interface LiveStreamPublishInfo {
  rtmp_url: string;
  srt_url: string;
  ingest_path: string;
  stream_key: string;
}

export const listLiveStreams = async (status?: string): Promise<LiveStream[]> => {
  const params = status ? { status } : {};
  const res = await axiosInstance.get<{ liveStreams: LiveStream[] }>('/live-streams', { params });
  return res.data.liveStreams;
};

export const getLiveStream = async (id: string): Promise<LiveStream> => {
  const res = await axiosInstance.get<{ liveStream: LiveStream }>(`/live-streams/${id}`);
  return res.data.liveStream;
};

export const endLiveStream = async (id: string): Promise<LiveStream> => {
  const res = await axiosInstance.post<{ liveStream: LiveStream }>(`/live-streams/${id}/end`);
  return res.data.liveStream;
};

export const createLiveStream = async (params: {
  title: string;
  description?: string;
  specialty_id?: string;
}): Promise<{ liveStream: LiveStream; publish: LiveStreamPublishInfo }> => {
  const res = await axiosInstance.post<{
    liveStream: LiveStream;
    publish: LiveStreamPublishInfo;
    playback: { hls_url: string };
  }>('/live-streams', params);
  return { liveStream: res.data.liveStream, publish: res.data.publish };
};

// 短命の HLS 視聴トークン付き URL を取得する（JWT を URL に露出させないため）
export const createHlsSession = async (
  id: string
): Promise<{ hls_url: string; expires_in: number }> => {
  const res = await axiosInstance.post<{ hls_url: string; expires_in: number }>(
    `/live-streams/${id}/hls-session`
  );
  return res.data;
};
